module.exports = __webpack_public_path__ + "img/AI.18d29f02.svg";